
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/simple",
      function () {
        return require("private-next-pages/examples/simple.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/simple"])
      });
    }
  